<template>
  <!------------------------------------------------->
  <!-- VIEW ----------------------------------------->
  <!------------------------------------------------->
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          Configurar timer de nuevo lanzamiento
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>

    <!------------------------------------------------->
    <!-- Drawer --------------------------------------->
    <!------------------------------------------------->

    <v-card flat min-height="100vh" color="grey lighten-3">
      <v-card-text style="overflow-y: auto; height: calc(100vh - 64px)">
        <v-container class="pa-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-btn color="primary" block @click="openDialogConfig()">
                  <v-icon left> add </v-icon>
                  agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table :headers="headers" :items="timers" class="elevation-1">
            <template v-slot:top>
              <v-dialog v-model="dialogDelete" max-width="480px">
                <v-card>
                  <v-card-title class="text-h5">
                    ¿Está seguro de eliminar este timer?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">
                      Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.actions="{ item }">
              <tr>
                <v-btn icon>
                  <v-icon @click="editItem(item)" color="primary">tune</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon @click="deleteItem(item)" color="red">delete</v-icon>
                </v-btn>
              </tr>
            </template>
            <template v-slot:item.organization_id="{ item }">
              <tr align="center">
                <td>{{ setOrganizationName(item) }}</td>
              </tr>
            </template>
            <template v-slot:item.title="{ item }">
              <tr align="center">
                <td class="truncateTitle">{{ item.title }}</td>
              </tr>
            </template>
            <template v-slot:item.status="{ item }">
              <tr
                v-if="item.status === 'disabled'"
                style="color: red"
                align="center"
              >
                <td>{{ item.status }}</td>
              </tr>
              <tr v-else style="color: green" align="center">
                <td>{{ item.status }}</td>
              </tr>
            </template>
            <template v-slot:item.enabled="{ item }">
              <tr align="center">
                <v-btn
                  small
                  v-if="item.status === 'enabled'"
                  block
                  color="primary"
                  @click="toDisable(item)"
                >
                  Deshabilitar
                </v-btn>
                <v-btn
                  small
                  v-else
                  block
                  color="primary"
                  @click="toEnable(item)"
                >
                  Habilitar
                </v-btn>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>

    <!------------------------------------------------->
    <!-- DIALOG TO MODIFY ----------------------------->
    <!------------------------------------------------->

    <v-dialog
      v-model="isOpenDialogConfig"
      persistent
      :overlay="true"
      max-width="1200px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="pa-4 pb-0"> Configurar Timer </v-card-title>
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="6" class="pt-0">
                <v-col cols="12">
                  <v-text-field
                    v-model="timerConfig.text_timer"
                    label="Mensaje de espera"
                    :rules="textRules"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="timerConfig.text_timeout"
                    label="Mensaje de timeout"
                    :rules="textRules"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-date-picker
                    v-model="picker"
                    full-width
                    :min="today"
                  ></v-date-picker>
                </v-col>
                <v-row class="px-4">
                  <v-col cols="6">
                    <v-text-field
                      v-model="timerConfig.hour"
                      :rules="timeRules"
                      label="Hora"
                      required
                      type="number"
                      min="0"
                      max="23"
                      @change="constraintHour"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="timerConfig.minute"
                      :rules="timeRules"
                      label="Minutos"
                      required
                      type="number"
                      min="0"
                      max="59"
                      @change="constraintMinute"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      v-model="timerConfig.cta_timer"
                      label="Botón de espera"
                      :rules="textRules"
                      required
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="timerConfig.link_timer"
                      label="Link de espera"
                      :rules="textRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      v-model="timerConfig.cta_timeout"
                      label="Botón de timeout"
                      :rules="textRules"
                      required
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="timerConfig.link_timeout"
                      label="Sección de afrus: /organization/recurrences"
                      :rules="textRules"
                      required
                    />
                  </v-col>
                </v-row>

                <v-switch
                  v-model="allOrganizations"
                  inset
                  label="Timer para todas las organizaciones"
                  class="px-2"
                ></v-switch>

                <v-row>
                  <v-col cols="6">
                    <v-autocomplete
                      :items="organizations"
                      item-text="name"
                      item-value="id"
                      v-model="timerConfig.organization_id"
                      label="Organizaciones"
                      outlined
                      hide-details
                      clearable
                      :disabled="allOrganizations"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="timerConfig.language_code"
                      :items="availableLanguages"
                      :rules="languageRules"
                      item-text="label"
                      item-value="language_code"
                      required
                      label="Lenguaje"
                    />
                  </v-col>
                </v-row>
                <v-card
                  min-height="50px"
                  max-height="350px"
                  class="mx-1"
                  style="overflow-y: scroll"
                >
                  <v-card-title> Organizaciones seleccionadas </v-card-title>
                  <v-chip-group column class="pa-2 pt-0">
                    <v-chip
                      v-for="organization in selectedOrganizations"
                      :key="organization.name"
                      @click="removeFromSelectedOrganizations(organization)"
                    >
                      {{ organization.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="primary"
            text
            width="100px"
            @click="closeDialogConfig()"
          >
            {{ $t("actions.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            width="100px"
            @click="saveTimerConfig()"
          >
            {{ $t("actions.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { organizationService } from "@/services/organization.service";
import { mapGetters, mapActions } from "vuex";
import BaseToolbar from "@/components/BaseToolbar.vue";

export default {
  name: "Organization",
  components: {
    BaseToolbar,
  },
  data() {
    return {
      titleRules: [(v) => !!v || "Title is required"],
      contentRules: [(v) => !!v || "Content is required"],
      textRules: [(v) => !!v || "Text is required"],
      organizationRules: [(v) => !!v || "Organization is required"],
      languageRules: [(v) => !!v || "Language is required"],
      timeRules: [
        (v) => !!v || "Time is required",
        (v) => /^\d+$/.test(v) || "Time must be a number",
      ],
      valid: true,
      dialogDelete: false,
      today: this.$moment().add(1, "days").format("YYYY-MM-DD"),
      organizations: [],
      selectedOrganizations: [],
      allOrganizations: false,
      availableLanguages: [
        { language_code: "es", label: "Español" },
        { language_code: "es_ca", label: "Español (Castellano)" },
        { language_code: "pt", label: "Portugués" },
        { language_code: "ptpt", label: "Portugués (Portugal)" },
        { language_code: "en", label: "Inglés" },
      ],
      headers: [
        {
          text: "Texto de espera",
          align: "start",
          sortable: false,
          value: "text_timer",
        },
        {
          text: "Lenguaje",
          value: "language_code",
        },
        { text: "Status", value: "status" },
        {
          text: this.$t("communication_by_org.table.actions"),
          value: "actions",
        },
        {
          text: this.$t("communication_by_org.table.enable"),
          value: "enabled",
        },
      ],
      submitLoading: false,
      isOpenDrawer: false,
      breadcrumbItems: [
        {
          text: "Comunicaciones",
          disabled: false,
        },
        {
          text: "Configurar comunicaciones por organización",
          disabled: true,
          href: "",
        },
      ],
      isOpenDialogConfig: false,
      timerConfig: {
        text_timer: null,
        text_timeout: null,
        cta_timer: null,
        cta_timeout: null,
        link_timer: "",
        link_timeout: "",
        day: "",
        hour: null,
        minute: null,
        language_code: "",
        organizations: [],
        status: "enabled",
      },
      defaultTimerConfig: {
        text_timer: null,
        text_timeout: null,
        cta_timer: null,
        cta_timeout: null,
        link_timer: "",
        link_timeout: "",
        day: "",
        hour: null,
        minute: null,
        language_code: "",
        organizations: [],
        status: "enabled",
      },
      picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  computed: {
    ...mapGetters({
      timers: "newReleaseTimer/timers",
    }),
    availableOrganizations() {
      return this.organizations.map((e) => {
        return {
          ...e,
          disabled: this.timers.some((item) => item.organization_id == e.id),
        };
      });
    },
  },
  async created() {
    this.getAllOrganizations();
    this.readTimers();
  },
  methods: {
    ...mapActions({
      getTimers: "newReleaseTimer/getTimers",
      putTimer: "newReleaseTimer/putTimer",
      deleteTimer: "newReleaseTimer/deleteTimer",
    }),

    async updateTimer() {
      await this.putTimer(this.timerConfig);
    },
    async destroyTimer() {
      await this.deleteTimer(this.timerConfig);
    },
    async readTimers() {
      await this.getTimers();
    },

    async getAllOrganizations() {
      try {
        const response = await organizationService.getAllOrganizations();
        this.organizations = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    toggleDrawerConfig(isOpen) {
      this.isOpenDrawer = isOpen;
    },
    closeDrawerConfig() {
      this.isOpenDrawer = false;
    },
    openDialogConfig() {
      this.isOpenDialogConfig = true;
    },
    closeDialogConfig() {
      this.isOpenDialogConfig = false;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.timerConfig = Object.assign({}, this.defaultTimerConfig);
      });
    },
    saveTimerConfig() {
      if (this.$refs.form.validate()) {
        this.updateTimer();
        this.closeDialogConfig();
      }
    },
    deleteItem(item) {
      this.timerConfig = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.destroyTimer();
      this.closeDelete();
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.timerConfig = Object.assign({}, this.defaultTimerConfig);
        this.$refs.form.resetValidation();
      });
    },
    editItem(item) {
      this.timerConfig = Object.assign({}, item);
      this.allOrganizations = this.organizations.length === this.timerConfig.organizations.length
      this.selectedOrganizations = this.organizations.filter((org) => {
        return this.timerConfig.organizations.some((selected) => selected === org.id)
      })
      this.openDialogConfig();
    },
    setOrganizationName(item) {
      return this.organizations.find((e) => e.id == item.organization_id).name;
    },
    toDisable(item) {
      this.timerConfig = Object.assign({}, item);
      this.timerConfig.status = "disabled";
      this.updateTimer();
      this.closeDialogConfig();
    },
    toEnable(item) {
      this.timerConfig = Object.assign({}, item);
      this.timerConfig.status = "enabled";
      this.updateTimer();
      this.closeDialogConfig();
    },
    removeFromSelectedOrganizations(value) {
      const index = this.selectedOrganizations.findIndex(
        (org) => org.id === value.id
      );
      const erased = this.selectedOrganizations.splice(index, 1);
      this.organizations.push(erased[0]);
    },
    constraintHour(newValue) {
      if (newValue > 23) {
        this.timerConfig.hour = 23;
      } else if (newValue < 0) {
        this.timerConfig.hour = 0;
      }
    },
    constraintMinute(newValue) {
      if (newValue > 59) {
        this.timerConfig.minute = 59;
      } else if (newValue < 0) {
        this.timerConfig.minute = 0;
      }
    },
  },
  watch: {
    "timerConfig.organization_id"(value) {
      const organization = this.organizations.find((org) => org.id === value);
      this.selectedOrganizations.push(organization);
      this.organizations = this.organizations.filter((org) => org.id !== value);
    },
    allOrganizations(value) {
      if (value) {
        this.selectedOrganizations = this.organizations.map((org) => org);
      } else {
        this.selectedOrganizations = [];
      }
    },
    picker(value) {
      this.timerConfig.day = value;
    },
    selectedOrganizations() {
      this.timerConfig.organizations = this.selectedOrganizations.map(
        (org) => org.id
      );
    },
  },
};
</script>

<style scoped>
.truncateTitle {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
